import httpClient from "@/api/config";

export default{
	namespaced: true,

	state:{
		usersIndex:{},
		roles:[],
	},

	actions:{
		fetchRoles({commit}){
			return httpClient.get('/v2/user/roles')
				.then(({data:{roles}}) => {
					commit("setRoles",roles)
				});
		},

		banUser({commit},user_uuid){
			return httpClient
				.patch(`/v2/user/${user_uuid}/toggle-banned`)
				.catch(({response}) => {
					let{data, status} = response;
					if(status === 404){
						commit('error/setErrorStatusCode', status, {root:true});
						commit('error/setErrorDialogStatus', true, {root: true});
						commit('error/setErrorDialogMessage', data.error.message, {root: true})
					}
					if(status === 401){
						commit('error/setErrorDialogStatus', true, {root: true});
						commit('error/setErrorDialogMessage', data.error.message, {root: true})
					}
					return Promise.reject(data.error);
				});
		},

		addUser(context, data){
			return httpClient.post('/v2/user',data);
		},

		updateUser(context, {data, user_uuid}){
			return httpClient.put(`/v2/user/${user_uuid}`,data);
		},

		deleteUser(context,user_uuid){
			return httpClient.delete(`${process.env.VUE_APP_URL}/v2/user/${user_uuid}`);
		}

	},

	mutations:{
		setRoles(state,roles){
			state.roles = roles;
		},
	},

	getters:{

	}
}
